import React, { useState, useEffect } from "react";

// API imports
import useAxios from "../../hooks/useAxios";
import jsonFormatAuth from "../../apis/jsonFormatAuth";
import { sanitizeThumbnailEntries } from "../../helpers/apiUtils/entryBrowserUtils";

import DataTable from "../DataTable/DataTable";

const EntryBrowser = ({
  patientId,
  setEntryBrowserModalOpen,

  // Comparison entry, calculation entries.
  comparisonItems,
  setComparisonItems,
  comparisonItemLocation,

  // Photo Entry.
  photoEntry,
  files,
  setFiles,
  filesDetails,
  setFilesDetails,
}) => {
  // Table
  const [entriesData, setEntriesData] = useState([]);
  const [patientTags, setPatientTags] = useState([]);

  // API Start
  const { response, axiosFetch } = useAxios();

  const getData = () => {
    axiosFetch({
      axiosInstance: jsonFormatAuth(),
      method: "GET",
      url: `entries/thumbnail_menu/${patientId}/`,
      sendSignal: false,
      requestConfig: {},
    });
  };

  useEffect(() => {
    // Obtain data from API on initial page load.
    getData();
  }, []);

  useEffect(() => {
    if (response) {
      // console.log(response);

      const actionCode = response?.action_code;

      if (actionCode === "thumbnail_entries_sent") {
        const thumbnailEntriesResponse = response?.payload?.thumbnail_entries;
        const patientTagsResponse = response.payload?.patient_tags;

        if (thumbnailEntriesResponse) {
          const sanitizedThumbnailEntriesResponse = sanitizeThumbnailEntries({
            thumbnailEntriesResponse,
          });
          setEntriesData(sanitizedThumbnailEntriesResponse);
        }

        if (patientTagsResponse) {
          setPatientTags(patientTagsResponse);
        } else {
          setPatientTags([]);
        }
      }
    }
  }, [response]);
  // API End

  return (
    <div className="flex flex-col flex-grow items-center w-full Xbg-lime-500">
      <DataTable
        data={entriesData}
        dataTags={patientTags}
        rowType={"entryThumbnail"}
        showFilter={true}
        showPageNav={true}
        additionalArgs={{
          setEntryBrowserModalOpen,
          // Comparison entry, calculation entries.
          comparisonItems,
          setComparisonItems,
          comparisonItemLocation,
          // Photo Entry.
          photoEntry,
          files,
          setFiles,
          filesDetails,
          setFilesDetails,
        }}
      />
    </div>
  );
};

export default EntryBrowser;
